import { Status, TextLink } from '@mm/components';
import { MessengerAdModel } from '@mm/state/model/MessengerAdModel';
import { UICampaignItem } from '@mm/state/reducers/campaignsOverview';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { ThreeDotMenu } from '../../../../../../../common/components/ThreeDotMenu/ThreeDotMenu';
import * as routes from '../../../../../../../common/constants/routes';
import { formatDateTime } from '../../../../../../../common/helpers/formatDateTime';
import { trackWebAppGAEvent } from '../../../../../../../common/helpers/plugins/website-google-analytics';
import { useDeleteCampaign } from '../../use-delete-campaign';
import { EntityRowBaseTemplate } from '../EntityRowBaseTemplate';
import { CampaignBaseInfo, Kind } from '../SharedCells';

const getLegacyAdStatusText = (messengerAd: MessengerAdModel) => {
  if (messengerAd.active) {
    return 'Active';
  }

  return 'Draft';
};

export const LegacyMessengerAdRow = ({ item }: { item: UICampaignItem }) => {
  const { history } = useRouter();
  const activeChatbotId = useSelector(activeChatbotIdSelector);

  const campaignName = item.adCampaignName;

  const subHeadingText = (campaignName && `Campaign: ${campaignName}`) || '';

  const updatedAt = `Updated at: ${formatDateTime(item.updatedAt || '')}`;

  const status = getLegacyAdStatusText(item as MessengerAdModel);

  const clickMessagesSent = '?';

  const navigateToEditRoute = () => {
    const path = `${routes.CHATBOT_EDITOR}/${activeChatbotId}/messenger-ads/edit/${item.id}`;
    history.push(path);
  };

  const onRowClick = () => {
    trackWebAppGAEvent('click', {
      category: 'campaigns_table',
      label: `table_item_messenger_ad_legacy_true`,
    });
    navigateToEditRoute();
  };

  const { deleteCampaign } = useDeleteCampaign();
  const onSelectItem = (menuItem: string) => {
    switch (menuItem) {
      case 'edit':
        return navigateToEditRoute();
      case 'delete':
        return deleteCampaign(item);
      default:
        break;
    }
  };

  const elements = [
    { name: 'Edit', value: 'edit' },
    { name: 'Delete', value: 'delete' },
  ];

  const onMenuClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <EntityRowBaseTemplate
      className="starters-table__data-row starters-table__data-row--large"
      onClick={onRowClick}
      inactive={status === 'Draft'}
    >
      <CampaignBaseInfo
        headingText={item.name}
        subHeadingText={subHeadingText}
      />

      <Kind kind="legacy_messenger_ads" />

      <TextLink>{updatedAt}</TextLink>
      <Status status={status} />

      <span />
      <span />
      <span />
      {/*      {!isLegacy ? <CountWithTitle count="?" text="Impressions" /> : <span />}
      <CountWithTitle count={clickMessagesSent} text="Clicks/Sent" />
      <CountWithTitle count="?" text="Responded" />*/}
      <ThreeDotMenu
        className="shared_cells__menu"
        onClick={onMenuClick}
        elements={elements}
        selectItem={onSelectItem}
      />
    </EntityRowBaseTemplate>
  );
};
